import { animate, scroll, inView, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const blockShowcase = document.querySelector('.block-showcase');
    
    // Check if the showcase  block exists
    if (!blockShowcase) {
        return;
    }

    const componentCardShowcaseFeatured = blockShowcase.querySelector('.component-card-showcase-featured');
    const componentCardShowcase = blockShowcase.querySelectorAll('.component-card-showcase');

    // Animations for blockShowcase
    if (blockShowcase) {
        inView(blockShowcase, () => {
            const blockShowcaseContent = blockShowcase.querySelector('.block-showcase__content');
            if (blockShowcaseContent) {
                animate(blockShowcaseContent, 
                    { 
                        opacity: [0, 1], 
                        transform: ['translateY(60px)', 'translateY(0)'],
                    }, 
                    { 
                        duration: 0.6, 
                        delay: 0.3     
                    }
                );
            }

            if (window.innerWidth >= 768) {
                const blockShowcaseHeading = blockShowcase.querySelector('.block-showcase__content__heading');
                if (blockShowcaseHeading) {
                    scroll(
                        animate(blockShowcaseHeading,
                            { y: [0, -300] },  
                            { ease: "ease-in-out" }
                        )
                    );
                }
            }
        });
    }

    // Component Card Showcase Featured Animations
    if (componentCardShowcaseFeatured) {
        inView(componentCardShowcaseFeatured, () => {
            animate(componentCardShowcaseFeatured, 
            { 
                opacity: [0, 1], 
                transform: ['translateY(60px)', 'translateY(0)'],
            }, 
            { 
                duration: 0.6, 
                delay: 0 
            });

            const featuredContent = componentCardShowcaseFeatured.querySelectorAll('.component-card-showcase-featured__content > *');
            if (featuredContent.length) {
                animate(featuredContent, 
                    { 
                        opacity: [0, 1], 
                        transform: ['translateY(60px)', 'translateY(0)'], 
                    }, 
                    { 
                        duration: 0.6, 
                        delay: stagger(0.3, { startDelay: 0.3 }) 
                    }
                );
            }

            const countElements = componentCardShowcaseFeatured.querySelectorAll('.component-card-showcase-featured__content__count');
            countElements.forEach((count) => {
                const dataCount = parseFloat(count.getAttribute('data-count'));
                if (!isNaN(dataCount)) {
                    animate(0, dataCount, {
                        duration: 2, 
                        delay: 1.4,
                        ease: "circOut",
                        onUpdate: (latest) => {
                            count.innerHTML = Math.round(latest) + '%';
                        }
                    }, {
                        delay: stagger(3)
                    });
                }
            });

            const mediaElement = componentCardShowcaseFeatured.querySelector('.component-card-showcase-featured__media');
            if (mediaElement) {
                animate(mediaElement, 
                    { 
                        opacity: [0, 1], 
                        transform: ['translateX(60px)', 'translateX(0)'],
                    }, 
                    { 
                        duration: 0.6, 
                        delay: 1.7     
                    }
                );
            }
        });
    }

    // Component Card Showcase Animations
    if (componentCardShowcase.length) {
        inView(componentCardShowcase, () => {
            animate(componentCardShowcase, 
            { 
                opacity: [0, 1], 
                transform: ['translateY(60px)', 'translateY(0)'],
            }, 
            { 
                duration: 0.6, 
                delay: stagger(0.3, { startDelay: 0.3 }) 
            });
        });
    }

    // Component Card Showcase Animations on Hover
    componentCardShowcase.forEach((card) => {
        card.addEventListener('mouseenter', () => {
            const countElements = card.querySelectorAll('.component-card-showcase__content__count');
            countElements.forEach((count) => {
                const dataCount = parseFloat(count.getAttribute('data-count'));

                // Check if dataCount is a valid number
                if (!isNaN(dataCount)) {
                    animate(0, dataCount, {
                        duration: 2,
                        ease: "circOut",
                        onUpdate: (latest) => {
                            count.innerHTML = Math.round(latest) + '%';
                        }
                    });
                }
            });
        });
    });
});